import type { BuilderEdits } from 'states';

/** Why this text cannot be used as the query or config, or '' when it can. */
export function editError(kind: keyof BuilderEdits, text: string): string {
  try {
    const parsed: unknown = JSON.parse(text);
    if (kind === 'query') return Array.isArray(parsed) && parsed.length > 0 ? '' : 'The query must be a list with at least one query in it.';
    return parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed) ? '' : 'The config must be a JSON object.';
  } catch {
    return 'This is not valid JSON yet, so the last valid version is still in use.';
  }
}
